<template>
  <hm-content title="">
    <div class="detail-Reward">
      <div class="caption">
        奖励方案
      </div>
      <ul>
        <li class="flex">
          <div class="title">方案名称：</div>
          <div class="content">{{ details.planName }}</div>
        </li>
        <li class="flex">
          <div class="title">生效时间：</div>
          <div class="content">
            {{ details.startTime }}至{{ details.endTime }}
          </div>
        </li>
        <li class="flex">
          <div class="title">参与门店：</div>
          <div class="content">{{ details.shopName }}</div>
        </li>
        <li class="flex">
          <div class="title">奖励类型：</div>
          <div class="content">
            {{
              details.rewardType === "fixed"
                ? "按数量固定奖励"
                : "按金额百分比奖励"
            }}
          </div>
        </li>
      </ul>
      <div class="goods mb20">
        <div class="caption">
          选择商品
        </div>
        <el-table
          stripe
          border
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="bindingType"
            label="关联类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.bindingType === 'goods'">
                商品
              </div>
              <div v-if="scope.row.bindingType === 'brand'">
                品牌
              </div>
              <div v-if="scope.row.bindingType === 'category'">
                品类
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            label="品类名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryId"
            label="品类编码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandId"
            label="品牌编码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品编码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="recommendedRetailPrice"
            label="商品价格"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      planId: this.$route.query.planId,
      details: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
    this.queryList();
  },
  methods: {
    async queryDetails() {
      const { result } = await this.$store.dispatch("detailRewardPlan", {
        planId: this.planId
      });
      this.details = result;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        planId: this.planId
      };
      const { result } = await this.$store.dispatch(
        "detailRewardPlanBindingInfo",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.detail-Reward {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 10px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
}
</style>
